import axios from "axios";
import { getApiUrl, getDomainId } from "../../config/tenant";

const getConfig = () => ({
    headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
    }
});

const domainQuery = () => `?Domain=${getDomainId()}`;

const fetchServices = () => {
    return axios.get(`${getApiUrl()}/services${domainQuery()}`, getConfig());
};

const fetchService = (id) => {
    return axios.get(`${getApiUrl()}/services/${id}${domainQuery()}`, getConfig());
};

const fetchServiceStaff = (id) => {
    return axios.get(`${getApiUrl()}/services/${id}/staff${domainQuery()}`, getConfig());
};

const fetchServiceAvailability = (id, start, end, staffId = null) => {
    let url = `${getApiUrl()}/services/${id}/availability${domainQuery()}&start=${start}&end=${end}`;
    if (staffId) url += `&staffId=${staffId}`;
    return axios.get(url, getConfig());
};

const fetchServiceAvailabilityWithUnavailable = (id, start, end, staffId = null) => {
    let url = `${getApiUrl()}/services/${id}/availability${domainQuery()}&start=${start}&end=${end}&includeUnavailable=true`;
    if (staffId) url += `&staffId=${staffId}`;
    return axios.get(url, getConfig());
};

export default {
    fetchServices,
    fetchService,
    fetchServiceStaff,
    fetchServiceAvailability,
    fetchServiceAvailabilityWithUnavailable
};
